<template>
  <form @submit.prevent="submitForm" novalidate goal-id="" submit-form>
    <div class="row">
      <div class="col-12">
        <BaseInput
            v-model="formData.name"
            label="Name"
            :validation="v$.name"
            :messages="v$.name.required.$message" />
      </div>
    </div>

    <div class="d-flex justify-content-center w-100 mt-3">
      <SaveButton
          :label="$t('general.button.save')"
          :loading="isSubmitting"/>
    </div>
  </form>
</template>

<script setup>
import coursePrivateCoachingModuleService from '@/api/Course/PrivateCoachingModule';
import BaseInput from '@/components/base/BaseInput.vue';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import { requiredRule } from '@/shared/validators/validationRules';
import useVuelidate from '@vuelidate/core';
import { computed, defineEmits, defineProps, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import SaveButton from '@/components/button/SaveButton.vue';

const { t }        = useI18n();
const isLoaded     = ref(false);
const isSubmitting = ref(false);
const emit         = defineEmits([ 'update:modelValue', 'update:submitForm' ]);

const props = defineProps({
  goalId: {
    type: Number,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const formData = ref({
  name: '',
});

const rules = computed(() => {
  return {
    name: requiredRule(t),
  };
});

const v$ = useVuelidate(rules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    if (props.goalId) {
      await coursePrivateCoachingModuleService.putRandomModuleGoal(formData.value, +props.goalId);
    } else {
      await coursePrivateCoachingModuleService.postRandomModuleGoal(formData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getGoalData(goalId) {
  try {
    const { data } = await coursePrivateCoachingModuleService.getRandomModuleGoal(+goalId);

    formData.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  if (props.goalId) {
    await getGoalData(props.goalId);
  }

  isLoaded.value = true;
});
</script>
<style scoped>

</style>